export default function () {
    
    if (jQuery('.js-title-cta--trigger-modal').length > 0) {
        jQuery('.js-title-cta--trigger-modal').on('click', function (event) {
            let modal = jQuery(this).closest('section').find('.js-title-cta--modal');
            event.preventDefault();
            console.log(modal);
            modal.addClass('active');
        });
        
        jQuery('.js-title-cta--close-modal').on('click', function () {
            let modal = jQuery(this).closest('.js-title-cta--modal');
            modal.removeClass('active');
        });
    }
}
